import { TableCell, TableRow, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ProgressButton } from '../../ProgressButton';
import { FinancialTableFooterProps } from '../FinancialTable.proptype';

const useStyles = makeStyles((theme) => ({
  tFooter: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:first-child': {
      borderBottom: '0'
    },
    '& > div': {
      padding: 0
    }
  }
}));

export const FinancialTableFooter = ({ columnYears, onSetCompletion, completionByYear }: FinancialTableFooterProps) => {
  const classes = useStyles();

  return (
    <TableRow component="div" className="tr">
      <TableCell component="div" className={clsx(classes.tFooter, 'td')} scope="row" />
      {columnYears.map((columnYear) => {
        return (
          <TableCell key={`${columnYear}footer`} component="div" className={clsx(classes.tFooter, 'td')} scope="row">
            {Number.isNaN(columnYear) ? null : (
              <ProgressButton
                complete={completionByYear[columnYear]}
                onChange={(complete) => {
                  onSetCompletion(columnYear, complete);
                }}
              />
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};
